import styled from 'styled-components';

export const StyledSBDModalWrapper = styled.div`
  position: relative;
  height: 400px;
`;
